module.exports = __webpack_public_path__ + "img/49200.057c7607.jpg";